import React, { useState } from 'react';
import { MessageSquareTextIcon, ClockIcon, UserIcon, HashIcon, ChevronDownIcon, ChevronUpIcon, SearchIcon, FilterIcon } from 'lucide-react';
import { mockPromptData } from '../utils/mockData';
const PromptItem = ({
  prompt
}) => {
  const [expanded, setExpanded] = useState(false);
  return <div className="border border-gray-200 rounded-lg overflow-hidden bg-white mb-4" data-id="element-424">
      <div className="p-4 flex flex-wrap items-center justify-between" data-id="element-425">
        <div className="flex items-center mb-2 md:mb-0" data-id="element-426">
          <div className={`w-2 h-2 rounded-full mr-3 ${prompt.type === 'chat' ? 'bg-blue-500' : 'bg-green-500'}`} data-id="element-427" />
          <span className="text-sm font-medium text-gray-500 mr-4" data-id="element-428">
            {prompt.timestamp}
          </span>
          <span className={`text-xs px-2 py-1 rounded mr-4 ${prompt.type === 'chat' ? 'bg-blue-100 text-blue-800' : 'bg-green-100 text-green-800'}`} data-id="element-429">
            {prompt.type === 'chat' ? 'Chat' : 'API'}
          </span>
          <span className="text-sm font-medium text-gray-700 mr-4 flex items-center" data-id="element-430">
            <UserIcon size={14} className="mr-1" data-id="element-431" />
            {prompt.userId}
          </span>
        </div>
        <div className="flex items-center flex-wrap" data-id="element-432">
          <div className="flex items-center mr-4" data-id="element-433">
            <HashIcon size={14} className="mr-1 text-gray-400" data-id="element-434" />
            <span className="text-sm text-gray-600" data-id="element-435">
              {prompt.tokenCount} tokens
            </span>
          </div>
          <div className="flex items-center mr-4" data-id="element-436">
            <ClockIcon size={14} className="mr-1 text-gray-400" data-id="element-437" />
            <span className="text-sm text-gray-600" data-id="element-438">{prompt.latency} ms</span>
          </div>
          <button onClick={() => setExpanded(!expanded)} className="text-blue-600 hover:text-blue-800 flex items-center text-sm" data-id="element-439">
            {expanded ? <>
                <ChevronUpIcon size={16} className="mr-1" data-id="element-440" />
                Hide Details
              </> : <>
                <ChevronDownIcon size={16} className="mr-1" data-id="element-441" />
                View Details
              </>}
          </button>
        </div>
      </div>
      {expanded && <div className="border-t border-gray-200 p-4 bg-gray-50" data-id="element-442">
          <div className="mb-4" data-id="element-443">
            <h4 className="text-sm font-medium text-gray-700 mb-2" data-id="element-444">Prompt</h4>
            <div className="bg-white p-3 rounded border border-gray-200 text-sm text-gray-800 whitespace-pre-wrap" data-id="element-445">
              {prompt.prompt}
            </div>
          </div>
          <div data-id="element-446">
            <h4 className="text-sm font-medium text-gray-700 mb-2" data-id="element-447">Response</h4>
            <div className="bg-white p-3 rounded border border-gray-200 text-sm text-gray-800 whitespace-pre-wrap" data-id="element-448">
              {prompt.response}
            </div>
          </div>
        </div>}
    </div>;
};
const PromptMonitoring = () => {
  const [prompts, setPrompts] = useState(mockPromptData);
  const [filters, setFilters] = useState({
    type: 'all',
    search: ''
  });
  const filteredPrompts = prompts.filter(prompt => {
    // Filter by type
    if (filters.type !== 'all' && prompt.type !== filters.type) {
      return false;
    }
    // Filter by search
    if (filters.search && !prompt.prompt.toLowerCase().includes(filters.search.toLowerCase())) {
      return false;
    }
    return true;
  });
  return <div className="space-y-6" data-id="element-449">
      <h1 className="text-2xl font-bold text-gray-800" data-id="element-450">Prompt Monitoring</h1>
      {/* Filters */}
      <div className="bg-white p-4 rounded-lg shadow-sm" data-id="element-451">
        <div className="flex flex-wrap items-center justify-between" data-id="element-452">
          <div className="flex items-center space-x-4 mb-4 sm:mb-0" data-id="element-453">
            <div className="flex items-center" data-id="element-454">
              <FilterIcon size={16} className="mr-2 text-gray-500" data-id="element-455" />
              <select value={filters.type} onChange={e => setFilters({
              ...filters,
              type: e.target.value
            })} className="border border-gray-300 rounded-md px-3 py-1 focus:outline-none focus:ring-2 focus:ring-blue-500" data-id="element-456">
                <option value="all" data-id="element-457">All Types</option>
                <option value="chat" data-id="element-458">Chat Only</option>
                <option value="api" data-id="element-459">API Only</option>
              </select>
            </div>
          </div>
          <div className="relative" data-id="element-460">
            <input type="text" value={filters.search} onChange={e => setFilters({
            ...filters,
            search: e.target.value
          })} placeholder="Search prompts..." className="pl-10 pr-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 w-full sm:w-64" data-id="element-461" />
            <SearchIcon size={18} className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400" data-id="element-462" />
          </div>
        </div>
      </div>
      {/* Prompts List */}
      <div className="space-y-2" data-id="element-463">
        <div className="flex items-center text-sm text-gray-500" data-id="element-464">
          <MessageSquareTextIcon size={16} className="mr-2" data-id="element-465" />
          <span data-id="element-466">Showing {filteredPrompts.length} requests</span>
        </div>
        {filteredPrompts.map((prompt, index) => <PromptItem key={index} prompt={prompt} data-id="element-467" />)}
        {filteredPrompts.length === 0 && <div className="bg-white p-8 rounded-lg shadow-sm text-center" data-id="element-468">
            <MessageSquareTextIcon size={40} className="mx-auto text-gray-300 mb-4" data-id="element-469" />
            <h3 className="text-lg font-medium text-gray-700 mb-2" data-id="element-470">
              No prompts found
            </h3>
            <p className="text-gray-500" data-id="element-471">
              Try adjusting your filters or search criteria
            </p>
          </div>}
      </div>
    </div>;
};
export default PromptMonitoring;